import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'custom-icon',
  templateUrl: './custom-icon.component.html',
  styleUrls: ['./custom-icon.component.scss'],
})
export class CustomIconComponent implements OnInit {
  @Input() iconName!: string;
  @Input() height: number;
  @Input() width: number;
  @Input() colorClass: number;
  @Input() color?: string;

  constructor() {}
  ngOnInit() {
    if (!this.height) {
      this.height = 20;
    }
    if (!this.width) {
      this.width = 20;
    }
  }
}
